import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RestService } from '../../../services/rest/rest.service';
import { AppService } from 'app/services/app/app.service';
import { map, Observable, tap } from 'rxjs';
import { Log } from 'app/core/logging/log';



@Injectable({ providedIn: 'root' })
export class LocationGuard  {

    constructor(
        private appService: AppService,
        private restService: RestService
    ) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {

        const kiosk = route.paramMap.get('kiosk');
        Log.info('LocationGuard', {kiosk});

        return this.ensureTenantLoaded(kiosk);
    }

    ensureTenantLoaded(kiosk: string): Observable<boolean> | boolean {
        if (this.appService.locationId && this.appService.kiosk === kiosk) {
            return true;
        }

        return this.restService.getLocation(kiosk).pipe(
            tap((locationId) =>{
                this.appService.kiosk = kiosk;
                this.appService.locationId = locationId;
                Log.debug('Location cargado:', {locationId});
            }),
            map((locationId) => Boolean(locationId))
        );

    }


}
